var React = require('react');

function FranceInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"m4 0v12c-2.209139 0-4-1.790861-4-4v-4c0-2.209139 1.790861-4 4-4z","fill":"#2273c9","key":0}),React.createElement("path",{"d":"m12 0v12c-2.209139 0-4-1.790861-4-4v-4c0-2.209139 1.790861-4 4-4z","fill":"#e34f4f","transform":"matrix(-1 0 0 1 20 0)","key":1}),React.createElement("path",{"d":"m4 0h4v12h-4z","fill":"#fff","fillRule":"nonzero","key":2})]));
}

FranceInline.defaultProps = {"height":"12","viewBox":"0 0 12 12","width":"12"};

module.exports = FranceInline;

FranceInline.default = FranceInline;
